import Mustache from 'mustache'
import MESSAGES from 'core/data-model/constants/bi-messages'
import { formatNumber } from 'core/service/lib/number-format'

export const taxGioRetirementDeductionBenefit = ({ taxDeduction }) => ({
  stack: [
    { text: MESSAGES.TAX_DEDUCTION_BENEFIT_TITLE, style: 'title', pageBreak: 'before' },
    { text: MESSAGES.TAX_DEDUCTION_BENEFIT_SUB_TITLE, bold: true },
    {
      text: `${MESSAGES.TAX_DEDUCTION_BENEFIT_SUB_DESCRIPTION} ${MESSAGES.GIO_TAX_DEDUCTION_BENEFIT_SUB_DESCRIPTION_STRONG}`,
    },
    {
      fontSize: 12,
      table: {
        widths: [300, '*'],
        body: [
          [
            MESSAGES.RETIREMENT_TAX_CONSENT_BENEFIT_SUB_LIST[0].description,
            {
              text: Mustache.render(MESSAGES.RETIREMENT_TAX_BENEFIT_SUB_LIST[0].benefit, {
                value: formatNumber(taxDeduction.taxDeductionRetirementForYear, 2, true),
              }),
              alignment: 'right',
            },
          ],
        ],
      },
      layout: 'noBorders',
      margin: [20, 0, 30, 0],
    },
    {
      stack: [
        MESSAGES.TAX_GIO_RETIREMENT_DEDUCTION_BENEFIT_SUB_ADDITIONAL,
        ' ',
        { text: `${MESSAGES.NOTE}: ` },
        {
          text: `${MESSAGES.RETIREMENT_TAX_CONSENT_BENEFIT_SUB_NOTES[0][0]} ${MESSAGES.RETIREMENT_TAX_CONSENT_BENEFIT_SUB_NOTES[0][1]}`,
          margin: [36, -13, 0, 0],
        },
        ' ',
      ],
      style: 'disclaimer',
    },
  ],
  style: 'groupRow',
})
